import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import { productSchema } from "../../Validation/Validation";
import Select from "react-select";
import { customStyles } from "../../utils/constant";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadMultiple from "../../Components/ImageUploadMultiple";
const AddProducts = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const [countryData, setCountryData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [qualityData, setQualityData] = useState([]);
  const [traceabilityData, setTraceabilityData] = useState([]);
  const [packSizeData, setPackSizeData] = useState([]);

  const fetchAllData = async () => {
    const apiList = [
      {
        url: "category/getWithoutPaginationCategory",
        setter: setCategoryData,
      },
      {
        url: "country/getWithoutPaginationCountries",
        setter: setCountryData,
      },
    ];

    try {
      const responses = await Promise.all(
        apiList.map((item) => axiosInstance.get(item.url)),
      );

      responses.forEach((res, index) => {
        apiList[index].setter(res.data?.data || []);
      });
    } catch (err) {
      setCountryData([]);
      setCategoryData([]);
    }
  };
  useEffect(() => {
    fetchAllData();
    if (editData?.categoryId) {
      fetchByCategory(editData?.categoryId?._id);
    }
  }, []);

  const fetchByCategory = async (categoryId) => {
    if (!categoryId) {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
      return;
    }

    try {
      const response = await axiosInstance.get(
        `category/getCategoryWiseQualityTraceability/${categoryId}`,
      );
      const data = response.data.data;
      setTraceabilityData(data.traceabilityIds || []);
      setQualityData(data.qualityIds || []);
      setPackSizeData(data.packSizeIds || []);
    } catch (err) {
      setQualityData([]);
      setTraceabilityData([]);
    }
  };
  const initalvalues = {
    sortOrder: editData?.sortOrder || 1,
    countryIds: editData?.countryIds?.map((item) => item._id) || [],
    categoryId: editData?.categoryId?._id || null,
    qualityId: editData?.qualityId?._id || null,
    traceabilityId: editData?.traceabilityId?._id || null,
    productTitle: editData?.productTitle || "",
    productLink: editData?.productLink || "",
    productSKU: editData?.productSKU || "",
    description: editData?.description || "",
    thumbnailImage: editData?.thumbnailImage,
    metaTitle: editData?.metaTitle || "",
    metaKeywords: editData?.metaKeywords || "",
    metaDescription: editData?.metaDescription || "",
    isActive: editData?.isActive ?? false,
    packSizeId: editData?.packSizeId?._id || null,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: productSchema,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const formData = new FormData();
        formData.append("sortOrder", values.sortOrder);
        formData.append("isActive", values.isActive);
        formData.append("productTitle", values.productTitle);
        formData.append("productLink", values.productLink);
        formData.append("productSKU", values.productSKU);
        formData.append("description", values.description);
        formData.append("metaTitle", values.metaTitle);
        formData.append("metaKeywords", values.metaKeywords);
        formData.append("metaDescription", values.metaDescription);
        formData.append("categoryId", values.categoryId);

        if (values?.packSizeId) {
          formData.append("packSizeId", values.packSizeId);
        }

        if (values?.traceabilityId) {
          formData.append("traceabilityId", values.traceabilityId);
        }
        if (values?.qualityId) {
          formData.append("qualityId", values.qualityId);
        }

        values.countryIds?.forEach((item) => {
          formData.append("countryIds[]", item);
        });
        const existingImages = [];
        values.thumbnailImage?.forEach((file) => {
          if (file instanceof File) {
            formData.append("thumbnailImage", file);
          } else if (typeof file === "string") {
            existingImages.push(file);
          }
        });
        formData.append(
          "existingThumbnailImage",
          JSON.stringify(existingImages),
        );
        const response = editingId
          ? await axiosInstance.put(
              `/product/updateProduct/${editingId}`,
              formData,
            )
          : await axiosInstance.post("/product/createProduct", formData);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/products", {
            state: {
              currentPage: editData?.currentPage || 1,
              perPage: editData?.perPage || 10,
            },
          });
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Products", path: "/products" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  const countryOptions = countryData.map((item) => ({
    label: item.countryName,
    value: item._id,
  }));

  const categoryOptions = categoryData.map((item) => ({
    label: item.categoryName,
    value: item._id,
  }));
  const qualityOptions = qualityData.map((item) => ({
    label: item.qualityName,
    value: item._id,
  }));
  const traceabilityOptions = traceabilityData.map((item) => ({
    label: item.traceabilityName,
    value: item._id,
  }));

  const packSizeOptions = packSizeData.map((item) => ({
    label: item.packSizeName,
    value: item._id,
  }));

  const colLength =
    qualityOptions?.length > 0 || traceabilityOptions?.length > 0
      ? "col-sm-6"
      : "col-sm-6";

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header ">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Product
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row gy-3 gx-3">
                  <div className="col-sm-6 ">
                    <div className="form-group">
                      <label
                        htmlFor="priceList-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="priceList-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="productTitle" className="col-form-label ">
                        Product Title
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="productTitle"
                        name="productTitle"
                        placeholder="Enter Product Title"
                        value={values.productTitle}
                        onChange={handleChange}
                      />
                      {touched.productTitle && errors.productTitle && (
                        <small className="text-danger">
                          {errors.productTitle}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="productLink" className="col-form-label ">
                        Product Link
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="productLink"
                        name="productLink"
                        placeholder="Enter Product Link"
                        value={values.productLink}
                        onChange={handleChange}
                      />
                      {touched.productLink && errors.productLink && (
                        <small className="text-danger">
                          {errors.productLink}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 ">
                    <div className="form-group">
                      <label htmlFor="productSKU" className="col-form-label ">
                        Product SKU
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="productSKU"
                        name="productSKU"
                        placeholder="Enter Product SKU"
                        value={values.productSKU}
                        onChange={handleChange}
                      />
                      {touched.productSKU && errors.productSKU && (
                        <small className="text-danger">
                          {errors.productSKU}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 ">
                    <label htmlFor="Countries" className="col-form-label ">Available Countries (Allow Multiple)</label>
                    <Select
                      options={countryOptions}
                      isClearable
                      isMulti
                      styles={customStyles}
                      value={countryOptions.filter((opt) =>
                        values.countryIds?.includes(opt.value),
                      )}
                      onChange={(selected) =>
                        setFieldValue(
                          "countryIds",
                          selected ? selected.map((item) => item.value) : [],
                        )
                      }
                      placeholder="Select Countries"
                    />
                    {touched.countryIds && errors.countryIds && (
                      <small className="text-danger">{errors.countryIds}</small>
                    )}
                  </div>

                  <div className="col-sm-6 ">
                    <label htmlFor="Category" className="col-form-label ">Category</label>
                    <Select
                      options={categoryOptions}
                      value={categoryOptions.find(
                        (opt) => opt.value === values.categoryId,
                      )}
                      isClearable
                      styles={customStyles}
                      onChange={(selected) => {
                        const value = selected?.value || null;
                        setFieldValue("categoryId", value);
                        setFieldValue("qualityId", null);
                        setFieldValue("traceabilityId", null);
                        fetchByCategory(value);
                      }}
                      placeholder="Select Category"
                    />
                    {touched.categoryId && errors.categoryId && (
                      <small className="text-danger">{errors.categoryId}</small>
                    )}
                  </div>

                  {qualityOptions && qualityOptions.length > 0 && (
                    <div className="col-sm-6  ">
                      <label htmlFor="Quality" className="col-form-label ">Quality</label>
                      <Select
                        options={qualityOptions}
                        value={qualityOptions.find(
                          (opt) => opt.value === values.qualityId,
                        )}
                        isClearable
                        styles={customStyles}
                        onChange={(selected) =>
                          setFieldValue("qualityId", selected?.value)
                        }
                        placeholder="Select Quality"
                      />
                      {touched.qualityId && errors.qualityId && (
                        <small className="text-danger">
                          {errors.qualityId}
                        </small>
                      )}
                    </div>
                  )}

                  {traceabilityOptions && traceabilityOptions.length > 0 && (
                    <div className="col-sm-6 ">
                      <label htmlFor="Source" className="col-form-label ">Source</label>
                      <Select
                        options={traceabilityOptions}
                        value={traceabilityOptions.find(
                          (opt) => opt.value === values.traceabilityId,
                        )}
                        isClearable
                        styles={customStyles}
                        onChange={(selected) =>
                          setFieldValue("traceabilityId", selected?.value)
                        }
                        placeholder="Select Source"
                      />
                      {touched.traceabilityId && errors.traceabilityId && (
                        <small className="text-danger">
                          {errors.traceabilityId}
                        </small>
                      )}
                    </div>
                  )}

                  {packSizeOptions && packSizeOptions.length > 0 && (
                    <div className="col-sm-6 ">
                      <label htmlFor="Pack Size" className="col-form-label ">Product Pack Size</label>
                      <Select
                        options={packSizeOptions}
                        value={packSizeOptions.find(
                          (opt) => opt.value === values.packSizeId,
                        )}
                        isClearable
                        styles={customStyles}
                        onChange={(selected) =>
                          setFieldValue("packSizeId", selected?.value)
                        }
                        placeholder="Select Pack Size"
                      />
                      {touched.packSizeId && errors.packSizeId && (
                        <small className="text-danger">
                          {errors.packSizeId}
                        </small>
                      )}
                    </div>
                  )}

                  <div className={colLength}>
                    <div className="form-group">
                      <label htmlFor="metaTitle" className="col-form-label ">
                        Meta Title
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="metaTitle"
                        name="metaTitle"
                        placeholder="Enter Meta Title"
                        value={values.metaTitle}
                        onChange={handleChange}
                      />
                      {touched.metaTitle && errors.metaTitle && (
                        <small className="text-danger">
                          {errors.metaTitle}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className={colLength}>
                    <div className="form-group">
                      <label htmlFor="metaKeywords" className="col-form-label ">
                        Meta Keywords
                      </label>
                      <input
                        className="form-control  border-dark "
                        id="metaKeywords"
                        name="metaKeywords"
                        placeholder="Enter Meta Keywords"
                        value={values.metaKeywords}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.metaKeywords && errors.metaKeywords && (
                        <small className="text-danger">
                          {errors.metaKeywords}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className={colLength}>
                    <div className="form-group">
                      <label
                        htmlFor="metaDescription"
                        className="col-form-label"
                      >
                        Meta Description
                      </label>
                      <textarea
                        className="form-control border-dark"
                        id="metaDescription"
                        name="metaDescription"
                        placeholder="Enter Meta Description"
                        rows={5}
                        style={{
                          resize: "vertical",
                          minHeight: "45px",
                        }}
                        value={values.metaDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.metaDescription && errors.metaDescription && (
                        <small className="text-danger">
                          {errors.metaDescription}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="description" className="col-form-label ">
                        Description
                      </label>
                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />
                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className={qualityOptions.length > 0 ? "col-sm-6" : "col-sm-12"}>
                    <ImageUploadMultiple
                      id="thumbnailImage"
                      label="Product Images"
                      value={values.thumbnailImage}
                      onChange={(files) =>
                        setFieldValue("thumbnailImage", files)
                      }
                      error={errors.thumbnailImage}
                      touched={touched.thumbnailImage}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                 

                    <Button
                    color="danger"
                    className="mx-2"
                    onClick={() =>
                      navigator("/products", {
                        state: {
                          currentPage: editData?.currentPage || 1,
                          perPage: editData?.perPage || 10,
                          search: editData?.search || "",
                        },
                      })
                    }
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProducts;
